import React, { useState, useEffect } from "react";
import { InputLabel,  Button, CircularProgress, Box, Modal } from "@mui/material";
import axios from "axios";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useUserAdmin } from "../../../admin/UserContext";
import { IoClose } from "react-icons/io5";

export const EditarSliderPortadaSelecion = ({ onclose, slider, fetchSliders }) => {
     const { Token} = useUserAdmin();
        const backendURL = process.env.REACT_APP_BACKEND_URL;
        const [sliders, setSliders] = useState([]);
        const [successAlertOpen, setSuccessAlertOpen] = useState(false);
        const [errorAlertOpen, setErrorAlertOpen] = useState(false);
        const [enviandoAlert, setEnviandoAlert] = useState(false);
        const [alertMessage, setAlertMessage] = useState('');
    const [formData, setFormData] = useState({
        imagen_fondo: null,
        imagen_logo: null,
        imagen_texto: null,
        imagen_maquina: null,
        responsivo: null
    });

    const [loading, setLoading] = useState(false);

    // Mostrar vista previa si ya existe una imagen
   const renderPreview = (file) => {
    if (!file) return null;
    const url = typeof file === "string"
        ? `${backendURL}/${file}` // <-- Agrega el dominio si es necesario
        : URL.createObjectURL(file);
    return <img src={url} alt="preview" style={{ width: "100%", marginBottom: 10 }} />;
};
    // Manejo de archivos

    const handleFileChange = (e, campo) => {
    const file = e.target.files[0];
    setFormData(prev => ({ ...prev, [campo]: file }));
};


    // Inicializar datos del slider seleccionado
    useEffect(() => {
        if (sliders) {
            setFormData({
  imagen_fondo: sliders.imagen_fondo || null,
  imagen_logo: sliders.imagen_logo || null,
  imagen_texto: sliders.imagen_texto || null,
  imagen_maquina: sliders.imagen_maquina || null,
  responsivo: sliders.responsivo || null,
});
            
        }
    }, [sliders]);

      useEffect(() => {
  if (!slider) return; // Evita hacer la petición si slider no está definido

  const fetchnewgetslider = async () => {
    try {
      const response = await axios.get(`${backendURL}/api/banner/especifico/${slider}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setSliders(response.data.data);
    } catch (error) {
      console.error("Error al obtener sliders:", error);
    }
  };

  fetchnewgetslider();
}, [slider, Token, backendURL]); 

const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setEnviandoAlert(true);

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
        if (value) data.append(key, value);
    });

    try {
        await axios.post(`${backendURL}/api/bannerUpdate/${slider}`, data, {
            headers: {
                Authorization: `Bearer ${Token}`,
                'Content-Type': 'multipart/form-data',
            },
        });

        setAlertMessage("Slider actualizado correctamente.");
        setSuccessAlertOpen(true);
        
    } catch (error) {
        setAlertMessage("Error al actualizar el slider.");
        setErrorAlertOpen(true);
        console.error("Error al actualizar:", error);
    } finally {
        setLoading(false);
        setEnviandoAlert(false);
        await fetchSliders()
        setTimeout(() => {
        setSuccessAlertOpen(false);
         setEnviandoAlert(false)
        setErrorAlertOpen(false);
        onclose();
       
      }, 3000);
    }
};
    return (
        <Box>
            <h3>Editar slider {slider}</h3>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen de fondo</InputLabel>
                    {renderPreview(sliders.imagen_fondo)}
                    <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "imagen_fondo")} style={inputStyle} />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen de logo</InputLabel>
                    {renderPreview(sliders.imagen_logo)}
                    <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "imagen_logo")} style={inputStyle} />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen de texto</InputLabel>
                    {renderPreview(sliders.imagen_texto)}
                    <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "imagen_texto")} style={inputStyle} />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen de máquina</InputLabel>
                    {renderPreview(sliders.imagen_maquina)}
                    <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "imagen_maquina")} style={inputStyle} />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Responsivo</InputLabel>
                    {renderPreview(sliders.responsivo)}
                    <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "responsivo")} style={inputStyle} />
                </div>


                <Button variant="contained" disabled={loading} sx={buttonStyle} type="submit">
                    {loading ? <CircularProgress size={24} /> : 'Guardar Slider'}
                </Button>
            </form>
            
                   <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                            <Box sx={modalStyle}>
                                <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                                    <IoClose style={{color:'#585857'}}/>
                                </section>
                                <section style={{ textAlign: 'center' }}>
                                    <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
                                    <p>{alertMessage}</p>
                                </section>
                            </Box>
                        </Modal>
            
                        {/* Modal de error */}
                        <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                            <Box sx={modalStyle}>
                                <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                                    <IoClose />
                                </section>
                                <section style={{ textAlign: 'center' }}>
                                    <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
                                    <p>{alertMessage}</p>
                                </section>
                            </Box>
                        </Modal>
            
                        {/* Modal de progreso */}
                        <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
                            <Box sx={modalStyle}>
                            <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                                    <IoClose />
                                </section>
                                <section style={{ textAlign: 'center', padding: '1rem' }}>
                                    <CircularProgress style={{ color: '#694B81' }} />
                                    <p>Procesando solicitud...</p>
                                </section>
                            </Box>
                        </Modal>
        </Box>
    );
};

const inputStyle = {
    border: "2px solid #585857",
    padding: "8px",
    borderRadius: "6px",
    width: "100%"
};


const buttonStyle = {
    backgroundColor: "#5E487B",
    color: "#fff",
    textTransform: "capitalize"
};


const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffff',
    border: '0px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: '10px'
};
